import React, { Component } from 'react'

export default class OgaSelect extends Component {

    constructor(props) {
        super(props);
    }

    handleChange(e) {
        let value = e.target.value;
        const filtered = this.props.options.filter(option => option.value == value);
        this.props.onChange(filtered[0]);
    }

    render() {
        let options = this.props.options;
        let curSelection = this.props.value;
        let style = this.props.bsSize && this.props.bsSize === "small" ? "form-control-sm" : "form-control-md";
        return (
            <div className={this.props.className}>
                <select
                    disabled={this.props.disabled}
                    onChange={(e) => { this.handleChange(e) }}
                    className={`form-control ${style}`} id="exampleFormControlSelect1" >
                    <option disabled selected hidden >{this.props.placeholder}</option>
                    {
                        options != undefined && options.map((e) => {
                            let isSelected = curSelection != null ? curSelection.value === e.value : false;
                            return (
                                <option value={e.value} selected={isSelected}>{e.label}</option>
                            )
                        })
                    }
                </select>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/elements/OgaSelect.jsx